import {createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '../../store';

// Define a type for the slice state
export interface MOTDState {
  motd: string
  typing: boolean
}

// Define the initial state using that type
const initialState: MOTDState = {
  motd: 'Loading...',
  typing: false
}

export const MOTDSlice = createSlice({
  name: 'MOTD',
  initialState,
  reducers: {
    setMOTD: (state, action: PayloadAction<string>)=>{
      if(!state.typing){
        state.motd = action.payload;
      }
    },
    editMOTD: (state, action: PayloadAction<string>)=>{
        state.motd = action.payload;
    },
    startTyping: (state)=>{
      if(!state.typing){
        state.typing = true;
      }
    },
    stopTyping: (state)=>{
      if(state.typing){
        state.typing = false;
      }
    }
  },
});
    

export const { setMOTD, startTyping, stopTyping, editMOTD} = MOTDSlice.actions

export const selectCount = (state: RootState) => state.MOTD.motd;

export default MOTDSlice.reducer